// when the user prints, this script will delay the print dialogue
// to ensure that the charts are fully rendered before printing
let printing = false;
let originalPrint = window.print;

document.addEventListener('DOMContentLoaded', function () {
	// Override the native print function
	window.print = function () {
		if (printing) {
			return; // Prevent multiple print calls
		}

		printing = true;

		// Add .printing class to the body
		document.body.classList.add('printing');

		// Delay the actual print to ensure styles/charts are rendered
		setTimeout(function () {
			printing = false; // Reset before calling original print
			originalPrint.call(window);
		}, 300); // Adjust the delay as needed
	};

	// Handle keyboard shortcuts (Ctrl+P / Cmd+P)
	document.addEventListener('keydown', function (e) {
		if ((e.ctrlKey || e.metaKey) && e.key === 'p') {
			e.preventDefault();
			window.print();
		}
	});

	// Clean up the printing class after print dialog is closed
	window.addEventListener('afterprint', function () {
		document.body.classList.remove('printing');
		printing = false;
	});
});
